/** Rodzaj pozycji katalogu, o którą pytamy o obłożenie — odpowiednik `CatalogRef.Kind` w backendzie. */
export enum CatalogRefKind {
  TOUR = 'TOUR',
  OPTION = 'OPTION',
  VARIANT = 'VARIANT',
  PRICE = 'PRICE',
}

export interface CatalogRefDto {
  kind: CatalogRefKind;
  id: string;
}

export interface AvailabilityQueryDto {
  tourId: string;
  refs: CatalogRefDto[];
}

export interface AvailabilityInfoDto {
  entityId: string;
  name: string;
  limit: number | null;
  currentCount: number;
  /** Backend serializuje `isFull()` jako `full`. */
  full: boolean;
  /** -1 oznacza brak limitu */
  availablePlaces: number;
}

export interface CatalogAvailabilityDto {
  kind: CatalogRefKind;
  availability: AvailabilityInfoDto;
}
